<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"/>


    <div v-if="list.length == 0" class="flex flex-col items-center justify-center">
      <img src="@/assets/images/no-items.svg" width="50%" style="max-width: 400px" alt="">
      <p class="text-center">
        You don't have any orders yet.
      </p>
    </div>
    <vs-table v-show="list.length > 0" ref="table" v-model="selected" pagination :max-items="itemsPerPage"
              :data="list">

      <template slot="thead">
        <vs-th>Code</vs-th>
        <vs-th>Date</vs-th>
        <vs-th sort-key="order_status">Order Status</vs-th>
        <vs-th sort-key="price">Order Amount</vs-th>
        <vs-th sort-key="price"></vs-th>

      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <p class="product-name font-medium truncate">CBS_ORDER-{{ tr.id }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.created_at }}</p>
          </vs-td>
          <vs-td>
            <vs-chip :color="getOrderStatusColor(tr.sts)" class="product-order-status">{{
              tr.sts_str }}
            </vs-chip>
          </vs-td>
          <vs-td>
            <p class="product-price">{{ tr.total_price | price}} </p>
          </vs-td>
          <vs-td>
            <vs-button @click="showDetail(tr)">
              Details
            </vs-button>
            <vs-button class="ml-4" color="success" @click="retryPayment(tr)" v-if="mustShowRePayment(tr)">
              Proceed with Payment
            </vs-button>
          </vs-td>

        </vs-tr>
        </tbody>
        <vs-prompt
          color="danger"
          @accept="refund"
          @close="refundDialog = false"
          :active.sync="refundDialog">
          <div class="con-exemple-prompt">
            Please enter your reference cause here
            <vs-textarea placeholder="Reason" v-model="refundReason"/>
          </div>
        </vs-prompt>
        <vs-popup classContent="popup-example" title="Order Details" :active.sync="orderDetailVisible">
          <vs-list>
            <vs-list-header title="Order Address" color="primary"></vs-list-header>

            <p>
              <b>{{toName}}</b>,
              <br>
              Phone: {{toPhone}},
              <br>
              Zip Code: {{toZip}}
              <br>
              Address: {{toAddress}}, {{toCity}} ,{{toProvince}}
            </p>
            <vs-divider></vs-divider>
            <vs-list-header title="Order items" color="warning"></vs-list-header>

            <vs-list-item v-for="item in tempOrder.items" :key="item.id" :title="item.title"
                          :subtitle="getSubOi(item)"></vs-list-item>
          </vs-list>
        </vs-popup>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import DataViewSidebar from './ui-elements/data-list/DataViewSidebar.vue'
  // import moduleOrder from "@/store/order/moduleOrder";
  import moment from 'moment';
  import axios from '@/axios';
  export default {
    components: {
      DataViewSidebar
    },
    data() {
      return {
        selected: [],
        // products: [],
        itemsPerPage: 4,
        isMounted: false,
        refundDialog: false,
        refundReason: undefined,
        orderDetailVisible: false,
        tempOrder: {},
        tempRefund: undefined,


        // Data Sidebar
        addNewDataSidebar: false,
        sidebarData: {},
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
      toName() {
        return _.get(this.tempOrder, 'shipping_address.company', '-')
      },
      toAddress() {
        return _.get(this.tempOrder, 'shipping_address.address', '-')
      },
      toPhone() {
        return _.get(this.tempOrder, 'shipping_address.phone', '-')
      },
      toZip() {
        return _.get(this.tempOrder, 'shipping_address.zip', '-')
      },
      toCity() {
        return _.get(this.tempOrder, 'shipping_address.city', '-')
      },
      toProvince() {
        return _.get(this.tempOrder, 'shipping_address.province', '-')
      },
      list() {
        return this.$store.state.order.list
      }
    },
    methods: {
      showDetail(item) {
        this.tempOrder = item;
        this.orderDetailVisible = true;
      },
      async retryPayment(item) {
        let res = await axios.post('api/set-order' , {order_id:item.id});
        window.location.href  = res.data.link;
      },
      mustShowRePayment(tr) {
        let days;
        try {
          let now = moment(new Date()); //todays date
          let end = moment(tr.created_at); // another date
          let duration = moment.duration(now.diff(end));
          days = duration.asDays();
        } catch (e) {
          days = 0;
        }

        return tr.sts == 1 && days < 30;
      },
      addNewData() {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      getSubOi(item) {
        return `Total: ${item.qty}  - (${item.price}RM)`
      },
      deleteData(id) {
        this.$store.dispatch("dataList/removeItem", id).catch(err => {
          console.error(err)
        })
      },
      rejectOrder(data) {
        this.tempRefund = data;
        this.refundDialog = true;
      },
      refund() {
        this.$vs.loading();
        this.$store.dispatch("eCommerce/refund", {
          id: this.tempRefund.id,
          reason: this.refundReason
        }).then(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'The request was successfully set',
            color: 'primary'
          })
          this.refundDialog = false;
        }).catch(() => {
          this.$vs.notify({
            title: 'Error processing data',
            color: 'danger'
          })
          this.refundDialog = false;
          this.$vs.loading.close();
        });
      },
      getOrderStatusColor(status) {
        if (status == 1) return "warning"
        if (status == 2) return "success"
        if (status == 3) return "danger"
        return "primary"
      },
      getPopularityColor(num) {
        if (num > 90) return "success"
        if (num > 70) return "primary"
        if (num >= 50) return "warning"
        if (num < 50) return "danger"
        return "primary"
      },
      toggleDataSidebar(val = false) {

        this.addNewDataSidebar = val
      }
    },
    created() {
      // if (!moduleOrder.isRegistered) {
      //     console.log('555' , 555);
      //     this.$store.registerModule('order', moduleOrder)
      //     moduleOrder.isRegistered = true
      // }
      this.$store.dispatch("order/fetch")
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>

<style lang="scss">
  #data-list-list-view {
    .vs-con-table {

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search {
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            & + i {
              right: 1rem;
            }

            &:focus + i {
              right: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

          td {
            padding: 20px;

            &:first-child {
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }

            &:last-child {
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }

          td.td-check {
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead {
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }

        th.td-check {
          padding: 0 15px !important;
        }

        tr {
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
